import { useFeatureFlag } from '../../../utils/featureFlags';
import { WorkflowStepType } from '../../../services/WorkflowService';

const BASE_STEP_TYPES = [WorkflowStepType.AutoAssignmentStep, WorkflowStepType.ApprovalStep];
const WITH_HST_STEP_TYPES = [...BASE_STEP_TYPES, WorkflowStepType.HstProvisioningStep];

/** Step types a workflow administrator can pick; HST provisioning only with the HstProvisioning flag on. */
export const useOfferedStepTypes = (): WorkflowStepType[] => (useFeatureFlag('HstProvisioning') ? WITH_HST_STEP_TYPES : BASE_STEP_TYPES);
